import { Camera, Sun, Layout, Aperture, Image as ImageIcon, Crop } from "lucide-react";

const TIPS = [
  {
    icon: Sun,
    title: "Luz natural, siempre",
    text: "La luz suave de la mañana o de últimas horas (10-11h o 17-18h) realza las texturas handmade sin saturar los colores. Evita el flash y la luz cenital de mediodía.",
  },
  {
    icon: Layout,
    title: "Fondo neutro y limpio",
    text: "Lino crudo, lino blanco, papel kraft, una pared lisa beige o el tono crema (#F9F6F0) de tu web. Coherencia entre fotos = catálogo profesional.",
  },
  {
    icon: Aperture,
    title: "Tres tomas por pieza",
    text: "1) Producto entero centrado (3:4). 2) Detalle (costura, acabado, textura). 3) En contexto (sobre tela, sobre cuerpo, en un bodegón). Esa variedad vende.",
  },
  {
    icon: Camera,
    title: "Móvil moderno = suficiente",
    text: "iPhone 12+ o Pixel/Samsung de gama media bastan. Usa modo retrato solo para detalles. Bloquea la exposición tocando la zona más clara.",
  },
  {
    icon: Crop,
    title: "Formato vertical 3:4",
    text: "Tu catálogo y redes (Instagram, Pinterest) priorizan vertical. Encuadra dejando aire arriba y abajo. Recortable después si hace falta cuadrado.",
  },
  {
    icon: ImageIcon,
    title: "Edición mínima",
    text: "Solo: exposición, balance de blancos cálido y un punto de contraste. Nada de filtros saturados. Quieres mostrar el material real, no una versión maquillada.",
  },
];

export default function PhotoTips() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 py-16" data-testid="photo-tips-page">
      <div className="text-center mb-12">
        <div className="label-tracked text-[#C27A62] mb-3">Guía rápida</div>
        <h1 className="font-serif-editorial text-5xl md:text-6xl text-[#1E1E1E]">
          Cómo fotografiar
          <br />
          tus piezas
        </h1>
        <p className="text-[#5C5C5C] mt-6 max-w-2xl mx-auto leading-relaxed">
          Una guía corta y práctica para que tus fotos transmitan lo que tus piezas
          ya tienen: textura, calidez y oficio. Pensada para móvil, sin equipo
          profesional.
        </p>
      </div>

      <div className="space-y-6">
        {TIPS.map((tip, i) => {
          const Icon = tip.icon;
          return (
            <div
              key={i}
              className="flex gap-6 bg-[#FAF9F5] border border-[#E5E0D8] p-6 md:p-8"
              data-testid={`tip-${i}`}
            >
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#1E1E1E] text-[#F9F6F0] flex items-center justify-center">
                  <Icon size={20} strokeWidth={1.5} />
                </div>
              </div>
              <div>
                <div className="label-tracked text-[#C27A62] mb-1">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-serif-editorial text-2xl mb-2">{tip.title}</h3>
                <p className="text-[#5C5C5C] leading-relaxed">{tip.text}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-16 bg-[#1E1E1E] text-[#F9F6F0] p-10 md:p-14 text-center">
        <h3 className="font-serif-editorial text-3xl md:text-4xl mb-4">
          Checklist exprés antes de publicar
        </h3>
        <ul className="text-[#F9F6F0]/80 space-y-2 text-left max-w-md mx-auto">
          <li>· ¿Hay luz natural?</li>
          <li>· ¿Fondo limpio y coherente?</li>
          <li>· ¿Tres ángulos por pieza?</li>
          <li>· ¿Formato vertical 3:4?</li>
          <li>· ¿Color real (no saturado)?</li>
          <li>· ¿Encuadre con aire?</li>
        </ul>
      </div>
    </div>
  );
}
